class Token {
  isValid (token) {
    const payload = this.payload(token)
    return !!payload
  }

  payload (token) {
    const payload = token.split('.')[1]

    return this.decode(payload)
  }

  decode (payload) {
    if (this.isBase64(payload)) {
      return JSON.parse(atob(payload))
    }
    return false
  }

  isBase64 (str) {
    try {
      return btoa(atob(str)).replace(/=/g, '') == str
    } catch (error) {
      return false
    }
  }
}

export default new Token()
